import { store } from "../reducers/store";
import { AUTH_LOGOUT } from "../reducers/authReducer";

//ADRESSE DE L'API
//En développement (npm start) : chemin relatif, redirigé vers localhost:3001 par le "proxy" du package.json
//En production (npm run build) : l'API en ligne
export const API_URL = process.env.NODE_ENV === "production" ? "https://api.vblc.fr" : "";

//APPEL À UNE ROUTE PROTÉGÉE DU BACK OFFICE
//Ajoute le jeton de connexion ("Authorization: Bearer …") et déconnecte l'utilisateur si le serveur répond 401 (session invalide).
//Utilisation : authFetch("/eventRoute/createEvent", { method: "POST", ... })
export async function authFetch(path, options = {}) {
  const token = store.getState().authReducer?.token;
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (response.status === 401) {
    store.dispatch({ type: AUTH_LOGOUT });
  }
  return response;
}
